import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSwitch',
  props: {
  gap: {
    type: String,
    default: '8px'
  },
  value: Boolean,
  disabled: Boolean,
  isReversed: Boolean
},
  setup(__props) {



return { __sfc: true, }
}

})